import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorPage from './common/error-page';
import WebsiteLayout from './common/website-layout';
import ECSignupPage from '../components/pages/ec-landing-pages/ec-signup-page';
import PricingPage from '../components/pages/landingPages/pricing-page';
import DiscoverCreators from '../components/pages/product/discover-creators';
import ManageCampaigns from '../components/pages/product/manage-campaigns';
import RecruitInfluencers from '../components/pages/product/recruit-influencers';
import AnalyzeInfluencers from '../components/pages/product/analyze-influencers';
import CreatorOutreach from '../components/pages/product/creator-outreach';
import CreatorPayments from '../components/pages/product/creator-payments';
import LandingPage from '../components/pages/landingPages/landing-page';
import CreatorsLandingPage from '../components/pages/landingPages/creators-landing-page';
import PrivacyPolicy from '../components/pages/landingPages/privacy-policy';
import TermsOfService from '../components/pages/landingPages/terms-of-service';
import UserLicense from '../components/pages/landingPages/user-license';
import CookiesAndIPPolicy from '../components/pages/landingPages/cookies-and-ip-policy';
import Jurisdiction from '../components/pages/landingPages/jurisdiction';
import ChildPrivacy from './pages/landingPages/child-privacy';
import Security from '../components/pages/landingPages/security';
import Copyright from '../components/pages/landingPages/copyright';
import DataTerms from '../components/pages/landingPages/data-terms';
import TaxInfo from '../components/pages/landingPages/tax-info';
import AIUse from '../components/pages/landingPages/ai-use';
import Grievance from '../components/pages/landingPages/grievance';
import DataRetention from '../components/pages/landingPages/data-retention';
import Vendors from '../components/pages/landingPages/vendors';
import HelpCenter from '../components/pages/landingPages/help-center';
import GettingStarted from '../components/pages/landingPages/helpdesk/help/getting-started';
import Payments from '../components/pages/landingPages/helpdesk/help/payments';
import Community from '../components/pages/landingPages/helpdesk/help/community';
import Troubleshooting from '../components/pages/landingPages/helpdesk/help/trouble-shooting';
import ContactSupport from '../components/pages/landingPages/helpdesk/help/contact-support';
import HelpDashboard from '../components/pages/landingPages/helpdesk/help/help-dashboard';
import AskUs from '../components/pages/landingPages/ask-us';
import Contact from '../components/pages/landingPages/contact';
import BlogPost from '../components/pages/blog/blog-post';
import Blogs from '../components/pages/blog/blogs';
import News from '../components/pages/landingPages/news';
import Jobs from '../components/pages/landingPages/jobs';
import BillingTerms from '../components/pages/landingPages/billing-terms';
import CreatorsAgreement from '../components/pages/landingPages/creators-agreement';
import TermsAndConditions from '../components/pages/landingPages/terms-and-conditions';
import DemoPage from '../components/pages/landingPages/demo-page';
import MediaMonitor from '../components/pages/product/media-monitor';
import MediaPlans from '../components/pages/product/media-plans';
import MediaAnalytics from '../components/pages/product/media-analytics';
import IndustriesPage from '../components/pages/landingPages/industries';
import FashionIndustryPage from '../components/pages/landingPages/industries/fashion-industry';

function AppRoutes() {

    return (
        <Routes>
            <Route path="/" element={<WebsiteLayout />}>
                <Route path="/creators" element={<CreatorsLandingPage />} />
                <Route path="/" element={<LandingPage />} />
                <Route path="/signup/for-businesses" element={<ECSignupPage />} />
                <Route path="/product/discover-creators" element={<DiscoverCreators />} />
                <Route path="/product/manage-campaigns" element={<ManageCampaigns />} />
                <Route path="/product/recruit-influencers" element={<RecruitInfluencers />} />
                <Route path="/product/analyze-influencers" element={<AnalyzeInfluencers />} />
                <Route path="/product/creator-outreach" element={<CreatorOutreach />} />
                <Route path="/product/creator-payments" element={<CreatorPayments />} />
                <Route path="/pricing-page" element={<PricingPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/user-license" element={<UserLicense />} />
                <Route path="/cookies-and-ip" element={<CookiesAndIPPolicy />} />
                <Route path="/jurisdiction" element={<Jurisdiction />} />
                <Route path="/child-privacy" element={<ChildPrivacy />} />
                <Route path="/security" element={<Security />} />
                <Route path="/copyright" element={<Copyright />} />
                <Route path="/data-terms" element={<DataTerms />} />
                <Route path="/tax-info" element={<TaxInfo />} />
                <Route path="/ai-use" element={<AIUse />} />
                <Route path="/grievance" element={<Grievance />} />
                <Route path="/data-retention" element={<DataRetention />} />
                <Route path="/vendors" element={<Vendors />} />
                <Route path="/help-center" element={<HelpCenter />} />
                <Route path="/help/getting-started" element={<GettingStarted />} />
                <Route path="/help/payments" element={<Payments />} />
                <Route path="/help/dashboard" element={<HelpDashboard />} />
                <Route path="/help/community" element={<Community />} />
                <Route path="/help/troubleshooting" element={<Troubleshooting />} />
                <Route path="/help/contact-support" element={<ContactSupport />} />
                <Route path="/ask-us" element={<AskUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blogs />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/news" element={<News />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/billing-terms" element={<BillingTerms />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/creators-agreement" element={<CreatorsAgreement />} />
                <Route path="/solutions/industries" element={<IndustriesPage />} />
                <Route path="/solutions/fashion" element={<FashionIndustryPage />} />
            </Route>
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/product/media-monitor" element={<MediaMonitor />} />
            <Route path="/product/media-plans" element={<MediaPlans />} />
            <Route path="/product/media-analytics" element={<MediaAnalytics />} />
        </Routes>
    )
}

export default AppRoutes;
